import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Menu,
  MenuItem,
  Button,
  Avatar,
} from "@mui/material";
import {
  Brightness4,
  Brightness7,
  Menu as MenuIcon,
  KeyboardArrowDown,
  Person,
} from "@mui/icons-material";
import { useState } from "react";
import Navigation from "./Navigation";
import { useAuth } from "../contexts/AuthContext";

export default function Header({
  darkMode,
  setDarkMode,
  mobileOpen,
  handleDrawerToggle,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { user, logout } = useAuth();
  const [timerMenu, setTimerMenu] = useState(null);
  const [resourcesMenu, setResourcesMenu] = useState(null);
  const [userMenu, setUserMenu] = useState(null);

  const handleTimerMenuOpen = (event) => setTimerMenu(event.currentTarget);
  const handleTimerMenuClose = () => setTimerMenu(null);
  const handleResourcesMenuOpen = (event) =>
    setResourcesMenu(event.currentTarget);
  const handleResourcesMenuClose = () => setResourcesMenu(null);
  const handleUserMenuOpen = (event) => setUserMenu(event.currentTarget);
  const handleUserMenuClose = () => setUserMenu(null);

  return (
    <AppBar position="sticky" sx={{ mb: 2 }}>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          maxWidth: "lg",
          width: "100%",
          mx: "auto",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontWeight: "bold",
                background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              TimeBaba
            </Typography>
          </Link>
        </Box>

        {!isMobile && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button
              color="inherit"
              endIcon={<KeyboardArrowDown />}
              onClick={handleTimerMenuOpen}
            >
              Timers
            </Button>
            <Menu
              anchorEl={timerMenu}
              open={Boolean(timerMenu)}
              onClose={handleTimerMenuClose}
              sx={{ mt: 1 }}
            >
              <MenuItem
                component={Link}
                to="/timer"
                onClick={handleTimerMenuClose}
              >
                Timer
              </MenuItem>
              <MenuItem
                component={Link}
                to="/stopwatch"
                onClick={handleTimerMenuClose}
              >
                Stopwatch
              </MenuItem>
              <MenuItem
                component={Link}
                to="/pomodoro"
                onClick={handleTimerMenuClose}
              >
                Pomodoro
              </MenuItem>
            </Menu>

            <Button
              color="inherit"
              endIcon={<KeyboardArrowDown />}
              onClick={handleResourcesMenuOpen}
            >
              Resources
            </Button>
            <Menu
              anchorEl={resourcesMenu}
              open={Boolean(resourcesMenu)}
              onClose={handleResourcesMenuClose}
              sx={{ mt: 1 }}
            >
              <MenuItem
                component={Link}
                to="/blog"
                onClick={handleResourcesMenuClose}
              >
                Blog
              </MenuItem>
              <MenuItem
                component={Link}
                to="/pi-challenge"
                onClick={handleResourcesMenuClose}
              >
                Pi Challenge
              </MenuItem>
              <MenuItem
                component={Link}
                to="/sponsorship"
                onClick={handleResourcesMenuClose}
              >
                Sponsorship
              </MenuItem>
            </Menu>

            {user ? (
              <>
                <IconButton onClick={handleUserMenuOpen} sx={{ ml: 2 }}>
                  <Avatar sx={{ width: 32, height: 32 }} alt={user.name}>
                    {user.name?.[0]}
                  </Avatar>
                </IconButton>
                <Menu
                  anchorEl={userMenu}
                  open={Boolean(userMenu)}
                  onClose={handleUserMenuClose}
                  sx={{ mt: 1 }}
                >
                  <MenuItem
                    component={Link}
                    to="/dashboard"
                    onClick={handleUserMenuClose}
                  >
                    Dashboard
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleUserMenuClose();
                      logout();
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <Button
                component={Link}
                to="/login"
                color="inherit"
                startIcon={<Person />}
              >
                Login
              </Button>
            )}

            <IconButton onClick={() => setDarkMode(!darkMode)} color="inherit">
              {darkMode ? <Brightness7 /> : <Brightness4 />}
            </IconButton>
          </Box>
        )}

        {isMobile && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Navigation
              isMobile={isMobile}
              mobileOpen={mobileOpen}
              onClose={handleDrawerToggle}
            />
            <IconButton onClick={() => setDarkMode(!darkMode)} color="inherit">
              {darkMode ? <Brightness7 /> : <Brightness4 />}
            </IconButton>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
